import * as GetDocumentImageTypes from 'src/actions/project/get-document-image/Types';
import {
  GetDocumentImageAction,
  GetDocumentImageAttempt,
  GetDocumentImageSuccess,
  GetDocumentImageFailure
} from 'src/actions/project/get-document-image/GetDocumentImage.actions';

export interface GetDocumentImageState {
  images: {
    [key: number]: File;
  };
  loading: boolean;
  error: boolean;
}

const initialState: GetDocumentImageState = {
  images: {},
  loading: false,
  error: false,
};

export function GetDocumentImageReducer(state: GetDocumentImageState = initialState,
                                        action: GetDocumentImageAction): GetDocumentImageState {
  const images = { ...state.images };

  switch (action.type) {
    case GetDocumentImageTypes.GET_DOCUMENT_IMAGE_ATTEMPT:
      delete images[(action as GetDocumentImageAttempt).payload];
      return { ...state, images: images, loading: true, error: false };
    case GetDocumentImageTypes.GET_DOCUMENT_IMAGE_SUCCESS:
      images[(action as GetDocumentImageSuccess).payload.documentId] =
        (action as GetDocumentImageSuccess).payload.image;
      return { ...state, images: images, loading: false, error: false };
    case GetDocumentImageTypes.GET_DOCUMENT_IMAGE_FAILURE:
      delete images[(action as GetDocumentImageFailure).payload];
      return {
        ...state,
        images: images,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/GetDocumentImage.reducer.tsx